import React from 'react'
import { Link } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { IconWithText } from '@share/components'

type Props = {
  //
}

const AppBarNotificationMenu: React.FC<Props> = () => {
  const { t } = useTranslation()
  return (
    <Dropdown>
      <Dropdown.Toggle variant="success" id="dropdown-basic" as={Link} to="#" className="nav-link">
        <IconWithText
          textFirst
          label={t('mainToolbar.notificationBtn')}
          icon="fa-bell"
          badge="5"
          badgeType="warning"
          data-toggle="dropdown"
          classes={{
            label: 'text-link',
            badge: 'navbar-badge'
          }}
        />
      </Dropdown.Toggle>

      {/* TODO: implement notifications IN PROGRESS */}
      <Dropdown.Menu className="dropdown-menu-lg dropdown-menu-right">
        {/* <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right dropdown-menu show"> */}
        <span className="dropdown-item dropdown-header">15 Notifications</span>
        <Link to="/" className="dropdown-item">
          <i className="fas fa-envelope mr-2">{' '}</i> 4 new messages
          <span className="float-right text-muted text-sm">3 mins</span>
        </Link>
        <Link to="/" className="dropdown-item">
          <i className="fas fa-users mr-2">{' '}</i> 8 friend requests
          <span className="float-right text-muted text-sm">12 hours</span>
        </Link>
        <Link to="/" className="dropdown-item">
          <i className="fas fa-file mr-2">{' '}</i> 3 new reports
          <span className="float-right text-muted text-sm">2 days</span>
        </Link>
        <Link to="/" className="dropdown-item dropdown-footer">See All Notifications</Link>
        {/* </div> */}
        {/* <Dropdown.Item href="#/action-1">Action</Dropdown.Item>
        <Dropdown.Item href="#/action-2">Another action</Dropdown.Item>
        <Dropdown.Item href="#/action-3">Something else</Dropdown.Item> */}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default AppBarNotificationMenu
